import api from "../axiosIntercepture";

export const saveCarton = async(params)=>{
    try{
        const response = await api.post('/packing/createCounter',params);
        return response;
    }

    catch(err){
        throw err?.response;
    }
}


export const getCartoonList = async(page, pageSize)=>{
    try{
        const response = await api.post(`/packing/getCartonList?page=${page+1}&pageSize=${pageSize}`);
        return response.data?.data;
    }

    catch(err){
        throw err?.response;
    } 
}


export const updateCarton=async(data,id)=>{
    try{
        const response = await api.post(`/packing/updateCarton/${id}`,data);
       return response;
    }

    catch(err){
        throw err?.response;
    } 
}